module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/apple-icon-76x76-892af989ac3acfb06010d10659f55c3c.png";